var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "raft-details-fieldgroup",
    class: {
      'large-header': _vm.isBioStyling
    }
  }, [_c('details', {
    attrs: {
      "id": _vm.detailsId,
      "open": !_vm.isCollapsed
    }
  }, [_c('summary', [_c('span', {
    staticClass: "summary-title"
  }, [_vm._v("\n        " + _vm._s(_vm.label) + "\n        "), _vm.required ? _c('sup', {
    staticClass: "form-group required"
  }, [_vm._v(" * ")]) : _vm._e()])]), _vm._v(" "), _c('p', {
    staticClass: "details-field-group-content"
  }, [_vm._t("content"), _vm._v(" "), _vm._t("default")], 2)])]);

}
var staticRenderFns = []

export { render, staticRenderFns }